/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Fromwhen1Inputs */

const de__field_fromwhen1 = /** @type {(inputs: _Field_Fromwhen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ab wann`)
};

/**

* @param {_Field_Fromwhen1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_fromwhen1 = /** @type {((inputs?: _Field_Fromwhen1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Fromwhen1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_fromwhen1(inputs)
});
export { _field_fromwhen1 as "_field_fromWhen" }